export default __webpack_public_path__ + "static/media/pliers-2.d0ff4031.png";